import React from "react";
import { ThemeModule } from "../modules/themes/theme.types";

type ThemeCardProps = {
  theme: ThemeModule;
};

export function ThemeCard({ theme }: ThemeCardProps) {
  const { title, description, level, estimatedDuration, keywords } = theme;

  return (
    <div className="mm-surface p-4 h-full flex flex-col">
      <div className="flex items-center justify-between mb-2 gap-2">
        <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
          {title}
        </h3>
        {estimatedDuration !== undefined && (
          <span className="text-[11px] rounded-full px-2 py-1 border border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200">
            ~ {estimatedDuration} min
          </span>
        )}
      </div>
      <p className="text-sm text-slate-600 dark:text-slate-300 mb-3">
        {description}
      </p>

      <div className="flex flex-wrap items-center gap-2 text-[11px] text-slate-500 dark:text-slate-300 mb-3">
        {level && (
          <span className="inline-flex items-center rounded-full px-2 py-1 border border-slate-200 bg-white dark:border-slate-600 dark:bg-slate-800">
            Niveau : {level}
          </span>
        )}
        {keywords?.map((kw) => (
          <span
            key={kw}
            className="inline-flex items-center rounded-full px-2 py-1 border border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200"
          >
            {kw}
          </span>
        ))}
      </div>
    </div>
  );
}
